import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const DeleteTestCaseFolderConfirmationModal = ({
  dropdownElInfo,
  deleteFolderOpen,
  setDeleteFolderOpen,
  setTestCasesToggler
}) => {
  const [loading, setLoading] = useState(false)

  const handleCloseDeleteDialog = () => {
    setDeleteFolderOpen(false)
  }

  const handleDeleteFolder = async () => {
    setLoading(true)
    try {
      const cycleId = dropdownElInfo?.cycleId
      const pageId = dropdownElInfo?.pageId || dropdownElInfo?.id
      if (!cycleId || !pageId) {
        setLoading(false)
        return
      }
      await PageService.removeCyclePage(cycleId, pageId)
      setTestCasesToggler(prev => !prev)
      setDeleteFolderOpen(false)
      setLoading(false)
    } catch (error) {
      console.log(error.message)
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={deleteFolderOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteTestCasesModal">
        <DialogTitle className="deleteTestCasesModalTitle">
          Confirm Delete Folder
        </DialogTitle>
        <DialogContent className="deleteTestCasesModalContent">
          <DialogContentText className="deleteTestCasesModalContentText">
            Are you sure you want to delete this folder? All contents inside will be permanently removed. This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteTestCasesModalActions">
          <Button className="deleteTestCasesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteTestCasesModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteTestCasesModalButton" onClick={handleDeleteFolder} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteTestCaseFolderConfirmationModal
